module.exports = __webpack_public_path__ + "img/bgVote.0f5e54db.png";